import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as FbIcon } from '@assets/images/icons/fb.svg';
import { ReactComponent as IgIcon } from '@assets/images/icons/ig.svg';
import { ReactComponent as LogoFooter } from '@assets/images/icons/logoFooter.svg';
import { ReactComponent as TwIcon } from '@assets/images/icons/tw.svg';

import useStyles from './styles';
import Grid from '@material-ui/core/Grid';

export interface IAccountsPayableFooter {}

const AccountsPayableFooter: FC<IAccountsPayableFooter> = () => {
  const css = useStyles();
  const { t } = useTranslation();

  return (
    <Grid container className={css.container}>
      <Grid container className={css.firstSection}>
        <Grid item xs={4} md={3}>
          <LogoFooter className={css.oysterLogo} />
        </Grid>
        <Grid item xs={4} md={3}>
          <span className={css.topic}>{t('accountsPayable.footer.ourSolutions')}</span>
          <a
            target="_blank"
            rel="noreferrer noopener"
            href="https://yaydoo.com/intereses-moratorios/"
            className={css.link}
          >
            <span>{t('accountsPayable.footer.porCobrar')}</span>
          </a>
        </Grid>
        <Grid item xs={4} md={3}>
          <span className={css.topic}>{t('accountsPayable.footer.legal')}</span>
          <a
            target="_blank"
            rel="noreferrer noopener"
            href="https://oyster-yaydoo.zendesk.com/hc/es-419/articles/13266057554715-T%C3%A9rminos-y-Condiciones"
            className={css.link}
          >
            <span>{t('accountsPayable.footer.termsAndConditions')}</span>
          </a>
          <a
            target="_blank"
            rel="noreferrer noopener"
            href="https://oyster-yaydoo.zendesk.com/hc/es-419/articles/13265962208795-Aviso-de-Privacidad"
            className={css.link}
          >
            <span>{t('accountsPayable.footer.privacyPolicies')}</span>
          </a>
        </Grid>
      </Grid>
      <Grid container className={css.secondSection}>
        <Grid item xs={5} sm={6} md={6}>
          <span className={css.adicionalInfo}>{t('accountsPayable.footer.rights')}</span>
        </Grid>
        <Grid item xs={5} sm={4} md={6}>
          <Grid container className={css.socialMedia}>
            <Grid item>
              <span className={css.adicionalInfo}>{t('accountsPayable.footer.findUs')}</span>
            </Grid>
            <Grid item>
              <div className={css.socialMediaIcons}>
                <a
                  target="_blank"
                  rel="noreferrer noopener"
                  href="https://www.instagram.com/yaydoo/"
                >
                  <IgIcon />
                </a>
                <a
                  target="_blank"
                  rel="noreferrer noopener"
                  href="https://www.facebook.com/YAYDOO/"
                >
                  <FbIcon />
                </a>
                <a target="_blank" rel="noreferrer noopener" href="https://twitter.com/yaydooapp">
                  <TwIcon />
                </a>
              </div>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default AccountsPayableFooter;
